module.exports = __webpack_public_path__ + "img/clock01.c8949079.svg";